import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { DashboardPage } from './dashboard.page';

const routes: Routes = [
  {
    path: '',
    component: DashboardPage
  },
  /*{
    path: 'users',
    loadChildren: () => import('./users/users.module').then(m => m.UsersPageModule)
  },*/
  {
    path: ':action',
    component: DashboardPage
  },
  {
    path: ':action/:id',
    component: DashboardPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DashboardPageRoutingModule { }
